import { Component, ViewChild } from '@angular/core';
import { CreateKeyValueRequest } from '@models/base/createKeyValueRequest.model';
import { AccionesDialog } from '@models/base/identificadores.model';
import { UpdateKeyValueRequest } from '@models/base/updateKeyValueRequest.model';
import { TipoPericiaService } from '@services/tipoPericia/tipoPericia.service';
import { DialogTipoPericiaGenericComponent } from '../dialog-tipo-pericia-generic/dialog-tipo-pericia-generic.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTable, MatTableModule } from '@angular/material/table';
import { BaseDto } from '@models/base/baseDto.model';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { SinDatosParaMostrarComponent } from '@component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';

@Component({
  standalone:true,
  imports:[CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    NgxSpinnerModule,
    AppRolesDirective, // tu directiva personalizada standalone
    SinDatosParaMostrarComponent],
  selector: 'app-list-tipo-pericia',
  templateUrl: './list-tipo-pericia.component.html',
  styleUrls: ['./list-tipo-pericia.component.css']
})
export class ListTipoPericiaComponent {

  data = false
  dataSource = new MatTableDataSource<BaseDto>();
  obj!: undefined
  displayedColumns: string[] = [];

  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;

private paginator!: MatPaginator;
private sort!: MatSort;

@ViewChild(MatSort) set matSort(ms: MatSort) {
  this.sort = ms;
  this.setDataSourceAttributes();
}

@ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
  this.paginator = mp;
  this.setDataSourceAttributes();
}

setDataSourceAttributes() {
  this.dataSource.paginator = this.paginator;
  this.dataSource.sort = this.sort;

  if (this.paginator && this.sort) {
    this.applyFilter(null);
  }
}

  constructor(
    public dialog: MatDialog,
    private tipoPericiaService: TipoPericiaService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver
  ) {
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumns = result.matches ?
        ['descripcion', 'accion'] :
        ['descripcion', 'accion'];
    });
  }


  ngOnInit() {
    this.getAll();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getAll() {
    this.spinner.show()
    this.tipoPericiaService.getAll()
      .subscribe(
        data => {
          this.spinner.hide()
          this.dataSource.data = data
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.spinner.hide()
          this.snackBar.showError(error, "Error");
        }
      )
  }

  openDialog(action: any, obj: { action?: any; }) {
    obj.action = action;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "30%"
    dialogConfig.autoFocus = false;
    dialogConfig.data = obj

    const dialogRef = this.dialog.open(DialogTipoPericiaGenericComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result.event == AccionesDialog.Agregar) {
        this.addRowData(result.data);
      } else if (result.event == AccionesDialog.Modificar) {
        this.updateRowData(result.data);
      } else if (result.event == AccionesDialog.Eliminar) {
        this.deleteRowData(result.data);
      }
    });
  }

  applyFilter(event: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }


  addRowData(row_obj: { descripcion: any; }) {
    this.spinner.show()
    let createKeyValueRequest = new CreateKeyValueRequest
    createKeyValueRequest.descripcion = row_obj.descripcion

    let existe = false
    this.dataSource.data.forEach((element, index) => {
      if (element.descripcion === row_obj.descripcion)
        existe = true
    });

    if (createKeyValueRequest && !existe) {
      this.tipoPericiaService.create(createKeyValueRequest)
        .subscribe(
          data => {
            this.spinner.hide()
            this.dataSource.data.push({
              id: data.entidad.id,
              descripcion: row_obj.descripcion
            });
            this.table.renderRows();
            this.dataSource.data = this.dataSource.data.filter((value: { id: number; descripcion: string; }, key: any) => {
              return true;
            }).sort((a, b) => a.descripcion.toString().localeCompare(b.descripcion.toString()));
            this.data = this.dataSource.data.length >= 1 ? true : false
            this.snackBar.showSuccess("Registro agregado correctamente.", "Exito");
          },
          error => {
            this.spinner.hide()
            this.snackBar.showError( error, "Error");
          }
        )
    }
    else {
      this.spinner.hide()
      this.snackBar.showWarn("El registro ya existe", "Error");
    }

  }
  updateRowData(row_obj: { id: number; descripcion: string; }) {
    this.spinner.show()
    let updateKeyValueRequest = new UpdateKeyValueRequest
    updateKeyValueRequest.id = row_obj.id
    updateKeyValueRequest.descripcion = row_obj.descripcion

    let existe = false
    this.dataSource.data.forEach((element, index) => {
      if (element.descripcion === row_obj.descripcion)
        existe = true
    });
    if (updateKeyValueRequest && !existe) {
      this.tipoPericiaService.update(updateKeyValueRequest)
        .subscribe(
          data => {
            this.spinner.hide()
            this.dataSource.data = this.dataSource.data.filter((value: { id: number; descripcion: string; }, key: any) => {
              if (value.id == row_obj.id) {
                value.descripcion = row_obj.descripcion;
              }
              return true;
            });
            this.data = this.dataSource.data.length >= 1 ? true : false
            this.snackBar.showSuccess("Registro actualizado correctamente.", "Exito");
          },
          error => {
            this.spinner.hide()
            this.snackBar.showError(error, "Error");
          })
    }
    else {
      this.spinner.hide()
      this.snackBar.showWarn("El registro ya existe", "Error");
    }
  }

  deleteRowData(row_obj: { id: number; }) {
    this.tipoPericiaService.delete(row_obj.id)
    .subscribe(
      data => {
        this.spinner.hide()
        this.dataSource.data = this.dataSource.data.filter((value: { id: number; }, key: any) => {
          return value.id != row_obj.id;
        });
        this.data = this.dataSource.data.length >= 1 ? true : false
        this.snackBar.showSuccess("Registro dado de baja correctamente.", "Exito");
      },
      error => {
        this.spinner.hide()
        this.snackBar.showError(error, "Error");
      })


  }
}
